<template>
  <div>
    <span>{{ codeText }}</span>
  </div>
</template>

<script>
import { getPassCode } from '@/api/index';
export default {
  data() {
    return {
      codeText: '获取短信验证码',
      timmer: null
    };
  },
  methods: {
    reset() {
      this.codeText = '获取短信验证码';
      clearInterval(this.timmer);
    },
    sendcode(mobile) {
      let _this = this;
      if (mobile === '' || !/^1[3-9]\d{9}$/.test(mobile)) {
        this.$message.error('请输入正确电话号码');
        return;
      }
      if (this.codeText === '获取短信验证码') {
        getPassCode(mobile).then(res => {
          if (res.code === 0 && res.data) {
            _this.$message.success('验证码发送成功');
            _this.timerCode();
          } else {
            _this.$message.error(res.msg);
          }
        });
      }
    },
    timerCode() {
      let time = 60;
      this.timmer = setInterval(() => {
        if (time === 0) {
          this.codeText = '获取短信验证码';
          clearInterval(this.timmer);
        } else {
          time--;
          this.codeText = time + 's';
        }
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/loginModel/sendPassCode.vue